import React from 'react';
import styles from './styles.module.css';

interface Props {
  text: string;
  anchor?: string;
}

export const ProfileTitle = ({ text, anchor }: Props) => {
  return (
    <div className={styles.container} id={anchor}>
      <h2 className={styles.text}>{text}</h2>
    </div>
  );
};
